import { AxiosResponse } from 'axios';

import { api } from '../../http';
import {
  Feedback,
  FeedbackApiResponse,
  FeedbackFile
} from '../../types/interfaces';

export const FeedbackService = {
  async read(signal?: AbortSignal): Promise<Feedback[]> {
    const response: AxiosResponse<FeedbackApiResponse> =
      await api.get<FeedbackApiResponse>('feedback/', {
        signal // Передаем signal для отмены запроса
      });

    // Extract itemsList and return it
    return response.data?.itemsList || [];
  },

  async getFilesByFeedback(
    feedbackId: number,
    signal?: AbortSignal
  ): Promise<FeedbackFile[]> {
    const response: AxiosResponse<FeedbackFile[]> = await api.get<
      FeedbackFile[]
    >(
      `feedbackFile/getByFeedback?id=${feedbackId}`,
      { signal } // Передаем signal для отмены запроса
    );
    return response.data || [];
  },

  async getFeedbackFileById(
    fileId: number,
    signal?: AbortSignal
  ): Promise<{ data: Blob; headers: any }> {
    const response: AxiosResponse<Blob> = await api.get(
      `feedbackFile/${fileId}`,
      {
        responseType: 'blob',
        signal // Передаем signal для отмены запроса
      }
    );
    return { data: response.data, headers: response.headers };
  }
};
